import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const fetchRegions = async (country?: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_REGIONS.url, {
        params: { ...(country ? { country } : {}) },
    });
    return response.data.results;
}

export const fetchLanguages = async (country?: string): Promise<Record<string, string>> => {
    const response = await axiosClient.get(apiConfig.FETCH_LANGUAGES.url, {
        params: { ...(country ? { country } : {}) },
    });
    const results = (response.data?.results ?? []) as { id: number | string; name: string }[];
    return Object.fromEntries(results.map((language) => [String(language.id), language.name]));
};